var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"box",staticClass:"home-banner-card",style:({ height: this.isMobile ? 'auto' : ((_vm.visibleWH.height) + "px") })},[_c('img',{ref:"img",attrs:{"alt":"","src":_vm.src}})])}
var staticRenderFns = []

export { render, staticRenderFns }